var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 flex flex-col justify-center space-y-6"},[_c('h2',{staticClass:"text-3xl font-bold text-gray-900"},[_vm._v("\n\t\t"+_vm._s(_vm.__("Welcome"))+"\n\t\t"+_vm._s(_vm.user.name)+",\n\t\t"+_vm._s(_vm.__("glad you are here!"))+"\n\t")]),_vm._v(" "),_c('p',[_vm._v("Ihr Konto wird geprüft und demnächst freigeschaltet")])])
}
var staticRenderFns = []

export { render, staticRenderFns }